import VueRouter from 'vue-router'
import Vue from 'vue'
import pathToRegexp from 'path-to-regexp'

import {
    routes,
    buildRoute,
    LANGUAGES
} from '@/router/routes'

import {
    app,
    menu
} from '@/store/index.js'
import {
    getLocale
} from '@/store/api/index'

import {
    i18n
} from '@/locale'

Vue.prototype.$trl = function({
    name,
    params = {},
    meta = {}
}) {
    const route = routes.reduce((acc, _) => {
        if (_.name === name) {
            acc = _
        } else if (_.children) {
            _.children.forEach(child => {
                if (child.name === name) {
                    acc = child
                }
            })
        }
        return acc
    }, {})
    let path = route.path
    if (!params.locale) {
        params.locale = this.$route.params.locale
    }
    if (route.meta && route.meta.localeRoutes) {
        path = route.meta.localeRoutes[params.locale]
    }
    if(path) {
      const toPath = pathToRegexp.compile(path)
      const newRoute = toPath(params)
      return newRoute
    } else {
      return {};
    }
}

Vue.use(VueRouter)

if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'
}
const contigue = ['Markets', 'Market']
const router = new VueRouter({
    routes,
    mode: 'history',
    // scrollBehavior(to, from) {
    //     if (contigue.indexOf(to.name) > -1 && contigue.indexOf(from.name) > -1) {
    //         return false
    //     } else {
    //         return {
    //             x: 0,
    //             y: 0
    //         }
    //     }
    // }
})

function previousRouteExist(path) {
    const link = router.resolve({
        path
    });
    if (link && link.resolved.name !== 'PageNotFound') {
        return link.resolved
    }
    return false

}

function checkLanguageFromRoute(to) {
    const regexp = pathToRegexp('/:locale/(.*)')
    const lang = regexp.exec(to.redirectedFrom)
    if (lang && LANGUAGES.indexOf(lang[1]) > -1) {
        return lang[1]
    } else {
        return false
    }
}

router.beforeEach((to, from, next) => {
    // Load data before first load page
    let locale = to.params.locale || 'en'
    if (!to.params.locale) {
        const pending = checkLanguageFromRoute(to)
        locale = pending || 'en'
    }
    if (!app.loaded || !app.language[locale]) {
        getLocale({
                lang: locale
            })
            .then((res) => {
                // window.console.log(res)
                menu.data = res.menu
                if (!app.language[locale]) {
                    i18n.setLocaleMessage(locale, res.locale)
                }
                app.language[locale] = true
                if (!app.loaded) {
                    app.loaded = true
                    router.addRoutes(buildRoute(res.custompages))
                    const existence = to.redirectedFrom ? previousRouteExist(to.redirectedFrom) : false
                    if (existence) {
                        next({
                            path: existence.path,
                            params: existence.params
                        })
                    } else {
                        if (to.name === 'PageNotFound') {
                            next({
                                name: 'PageNotFound',
                                params: {
                                    locale: locale
                                }
                            })
                        } else {
                            next({
                                path: to.fullPath
                            })
                        }
                    }
                } else {
                    next()
                }
            })
    } else {
        // Prevent page without language
        if (!to.params.locale) {
            const nextRoute = {
                name: to.name,
                params: JSON.parse(JSON.stringify(to.params))
            }
            nextRoute.params.locale = 'en'
            next(nextRoute)
        } else {
            if (to.meta.localeRoutes) {
                const pending = to.meta.localeRoutes[to.params.locale]
                const regexp = pathToRegexp(pending)
                const matchingLocaleRoute = regexp.test(to.path)
                if (!matchingLocaleRoute) {
                    const toPath = pathToRegexp.compile(pending)
                    const newPath = toPath(to.params)

                    next({
                        path: newPath,
                        replace: true
                    })
                } else {
                    next()
                }
            } else {
                next()
            }
        }
    }
})

export default router